import React, { useCallback, useMemo } from 'react';
import { CollectionManagementHeader } from 'components/common/general/CollectionManagementPanel';
import { AddEmployeesDropdown } from 'components/common/rfq/add-employess/AddEmployeesDropdown';
import { observer } from 'mobx-react-lite';
import { useMonitorAddEmployeesPageStore } from 'store/pages/rfq/monitor-add-employees/pageStore';
import { EmployeesStatusFilterDropdown } from 'components/common/add-employees/EmployeesStatusFilterDropdown';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';
import { debounce } from 'global/utils/debounce';
import { SubProgressFilterDropdown } from 'components/common/rfq/add-employess/SubProgressFilterDropdown';
import { useRootStore } from 'store/rootStore';
import { HeaderSectionStyled } from './styles';

export const TableManagementPanel: React.FC = observer(() => {
  const { paginationDelegate, employees } = useMonitorAddEmployeesPageStore();
  const { periodId, cartId, groupId } = useEnrollmentQuoteUrlParams();
  const { domainStoreV2 } = useRootStore();

  const debouncedSearch = useMemo(
    () =>
      debounce((searchValue: string) => {
        paginationDelegate.setFilterValue('employeeName', searchValue);
      }, 300),
    [paginationDelegate],
  );

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      debouncedSearch(e.target.value);
    },
    [debouncedSearch],
  );

  return (
    <CollectionManagementHeader
      elementsTitle="employees"
      page={paginationDelegate.page}
      currentElements={employees.length}
      totalElements={paginationDelegate.totalElements}
      elementsPerPage={12}
      onSearch={handleSearch}
      searchInputPlaceholder="Employee Name"
      headerSection={
        <HeaderSectionStyled>
          <AddEmployeesDropdown
            censusRedirectLink={`/census-monitor-add-employees-upload/${groupId}?periodId=${periodId}&cartId=${cartId}`}
            availableAddEmployeesActions={domainStoreV2.availableAddEmployeesActions}
          />
          <EmployeesStatusFilterDropdown paginationDelegate={paginationDelegate} />
          <SubProgressFilterDropdown paginationDelegate={paginationDelegate} />
        </HeaderSectionStyled>
      }
    />
  );
});
